import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { ICrudGetAction, ICrudDeleteAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IGloballyFreeSubscriptionPlan } from 'app/shared/model/globally-free-subscription-plan.model';
import { IRootState } from 'app/shared/reducers';
import { getEntity, deleteEntity } from './globally-free-subscription-plan.reducer';

export interface IGloballyFreeSubscriptionPlanDeleteDialogProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const GloballyFreeSubscriptionPlanDeleteDialog = (props: IGloballyFreeSubscriptionPlanDeleteDialogProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const handleClose = () => {
    props.history.push('/globally-free-subscription-plan');
  };

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const confirmDelete = () => {
    props.deleteEntity(props.globallyFreeSubscriptionPlanEntity.id);
  };

  const { globallyFreeSubscriptionPlanEntity } = props;
  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose}>Confirm delete operation</ModalHeader>
      <ModalBody id="satshrutApp.globallyFreeSubscriptionPlan.delete.question">
        Are you sure you want to delete this GloballyFreeSubscriptionPlan?
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp; Cancel
        </Button>
        <Button id="jhi-confirm-delete-globallyFreeSubscriptionPlan" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp; Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = ({ globallyFreeSubscriptionPlan }: IRootState) => ({
  globallyFreeSubscriptionPlanEntity: globallyFreeSubscriptionPlan.entity,
  updateSuccess: globallyFreeSubscriptionPlan.updateSuccess,
});

const mapDispatchToProps = { getEntity, deleteEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(GloballyFreeSubscriptionPlanDeleteDialog);
